<template>
  <div style="overflow-x: auto">
    <b-table
      v-if="pagination"
      :columns="columns"
      :data="loading ? [] : lista_parcelas"
      :loading="loading"
      backend-pagination
      paginated
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :total="pagination.total"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
      style="width: 120%"
    >
      <template slot-scope="props" v-if="props.row.id != null">
        <b-table-column style="width: 150px" field="valor">
          <InputMoney placeholder="Digite um valor" v-model="props.row.valor" />
        </b-table-column>
        <b-table-column style="width: 150px" field="data_vencimento">
          <Lynx-Input
            type="date"
            v-model="props.row.data_vencimento"
            placeholder="Digite a data de vencimento"
          />
        </b-table-column>
        <b-table-column style="width: 250px" field="status">
          <Treeselect
            :multiple="false"
            v-model="props.row.status"
            :options="[
              { id: 1, label: 'Pago' },
              { id: 2, label: 'Aguardando Pagamento' },
              { id: 3, label: 'Atrasado' },
              { id: 4, label: 'Não efetuou Pagamento' },
            ]"
            placeholder="Selecione um status"
          />
        </b-table-column>

        <b-table-column field="pagamento">
          <Lynx-Input
            type="date"
            v-model="props.row.pagamento"
            placeholder="Digite a data de pagamento"
          />
        </b-table-column>
        <b-table-column field="envio">
          <b-switch
            v-model="props.row.envio"
            true-value="1"
            false-value="0"
            size="is-small"
            rounded
            type="is-success"
          />
        </b-table-column>

        <b-table-column style="width: 200px" field="updated_at">
          {{ formatEnToBr(props.row.updated_at) }}
        </b-table-column>
        <b-table-column field="acoes">
          <div class="flex text-sm">
            <div class="flex text-sm items-center">
              <Lynx-Button
                class=""
                icon-size="4"
                icon="Save"
                size="small"
                @click.native="atualizar(props.row)"
              />
              <Lynx-Button
                class=""
                icon-size="4"
                icon="Trash"
                color="error-base"
                size="small"
                @click.native="confirmDelete(props.row)"
              />
            
             <Logs v-if="props.row.logs.length > 0" :logs="props.row.logs" />

            </div>
          </div>
        </b-table-column>
      </template>
      <template v-slot:empty>
        <NotFoundData text="Nenhum tipo encontrado!" />
      </template>
    </b-table>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { monthNames } from "@/utils/utils";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import moment from "moment";
import InputMoney from "@/components/helpers/InputMoney";
import Logs from "@/views/logs/Logs";

export default {
  props: {
    parcelamentoEmpresaId: {
      type: Number,
      required: true,
    },
  },
  components: { NotFoundData, Treeselect, InputMoney,Logs },
  data() {
    return {
      monthNames,
      loading_inicial: false,
      loading: false,
      logs: [],
      modalLogs: false,
      lista_campos: [],
      motivosOptions: [],
      status_logs: {
        updated: "Atualizou",
        created: "Criou",
        deleted: "Deletou",
      },
      columns: [
        {
          field: "valor",
          label: "valor",
          sortable: true,
        },

        {
          field: "data_vencimento",
          label: "Data vencimento",
        },
        {
          field: "status",
          label: "status",
        },
        {
          field: "pagamento",
          label: "Pagamento",
        },
        {
          field: "envio",
          label: "Envio",
        },
        {
          field: "updated_at",
          label: "Ultima Atualização",
        },
        {
          field: "acoes",
          label: "Ações",
        },
      ],
      filtros: {
        page: 1,
        perPage: 10,
        parcelamento_empresa_id: null,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    lista_parcelas() {
      return this.$store.state.parcela.lista_parcelas.data;
    },
    pagination() {
      return this.$store.state.parcela.lista_parcelas.pagination;
    },
    mensagem_alert() {
      return this.$store.state.parcela.mensagem_alert;
    },
  },

  watch: {
    "filtros.perPage"() {
      this.listar_parcelas();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.listar_parcelas();
    },
    parcelamentoEmpresaId() {
      this.listar_parcelas();
    },
  },

  created() {
    this.inicial();
  },
  methods: {
    hasRole,
    async inicial() {
      await this.listar_parcelas();
    },
    confirmDelete(parcela) {
      this.$buefy.dialog.confirm({
        message: `Esta ação irá excluir o tipo de parcelamento do sistema. Deseja continuar?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-danger",
        onConfirm: () => {
          this.delete(parcela);
        },
      });
    },
    delete(parcela) {
      this.loading = true;
      this.$store
        .dispatch("parcela/delete_parcela", parcela)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.listar_parcelas();
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));
    },

    hideModalTipoParcelamento() {
      this.modalTipoParcelamento = false;
    },

    showModalTipoParcelamento() {
      this.modalTipoParcelamento = true;
    },

    async listar_parcelas() {
      this.loading = true;
      this.filtros.parcelamento_empresa_id = this.parcelamentoEmpresaId;
      const { filtros } = this;
      await this.$store.dispatch("parcela/listar_parcelas", filtros);
      this.loading = false;
    },

    async atualizar(value) {
      this.loading = true;
      const data = {
        id: value.id,
        valor: value.valor,
        data_vencimento: value.data_vencimento,
        parcelamento_empresa_id: value.parcelamento_empresa_id,
        pagamento: value.pagamento,
        status: value.status,
        envio: value.envio,
      };
      await this.$store
        .dispatch("parcela/update_parcela", data)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((error) => {
          this.$snack.error(this.mensagem_alert.message);
        })
        .finally(() => (this.loading = false));
    },

    onPageChange(page) {
      this.current_page = page;
    },
    openLogs(logs) {
      this.logs = logs;
      this.modalLogs = true;
    },

    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD HH:mm:ss").format(
        "DD/MM/YYYY HH:mm:ss"
      );

      if (momentDate != "Invalid date") {
        return momentDate;
      } else {
        return "sem data";
      }
    },
  },
};
</script>

<style scoped>
</style>
  